(function () {
  'use strict';
  const DEBUG = true;   // set false when done

  function apply() {
    const parcel = document.getElementById('parcel');
    if (!parcel) return false;

    const noShipping  = window.MK_NO_SHIPPING === true;
    const courierOnly = window.MK_COURIER_ONLY === true;

    document.body.classList.toggle('mk-no-shipping', noShipping);
    document.body.classList.toggle('mk-courier-only', !noShipping && courierOnly);

    if (DEBUG) console.log('[mk] noShipping:', noShipping, 'courierOnly:', courierOnly);

    if (noShipping) return true;

    if (courierOnly) {
      const courier = document.getElementById('courier');
      if (courier && !courier.checked) {
        const lbl = document.querySelector('label[for="courier"]');
        (lbl || courier).click();
      }
    }
    return true;
  }

  if (!apply()) {
    const mo = new MutationObserver(() => { if (apply()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 15000);
  }
})();